import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import pluralize from 'pluralize';
import QuestionsContainer from '../common/QuestionsContainer';
import './InterestInProjectSubmitted.scss';
var InterestInProjectSubmitted = /*#__PURE__*/function (_Component) {
  function InterestInProjectSubmitted(props) {
    var _this;
    _classCallCheck(this, InterestInProjectSubmitted);
    _this = _callSuper(this, InterestInProjectSubmitted, [props]);
    _this.state = {
      showModal: true,
      showQuestion: false
    };
    _this.handleCloseModal = _this.handleCloseModal.bind(_this);
    return _this;
  }
  _inherits(InterestInProjectSubmitted, _Component);
  return _createClass(InterestInProjectSubmitted, [{
    key: "handleCloseModal",
    value: function handleCloseModal(reload) {
      this.setState({
        showModal: false
      });
      if (reload) {
        window.location.href = "".concat(location.protocol, "//").concat(location.host).concat(location.pathname);
      }
    }
  }, {
    key: "handleShowQuestion",
    value: function handleShowQuestion() {
      this.setState({
        showQuestion: true
      });
    }
  }, {
    key: "renderInterestedCreated",
    value: function renderInterestedCreated(primaryQuestion) {
      var _this2 = this;
      var associations = this.props.associations;
      return /*#__PURE__*/React.createElement("div", {
        className: "interest-created-message"
      }, /*#__PURE__*/React.createElement("h1", {
        className: "mt-15 mb-15"
      }, "Success, resume submitted!"), /*#__PURE__*/React.createElement("div", {
        className: "body-text-1"
      }, "You started an application for this project. Clora will follow up with next steps."), primaryQuestion && associations && /*#__PURE__*/React.createElement("div", {
        className: "profile-completion-suggestion"
      }, /*#__PURE__*/React.createElement("h4", {
        className: "mb-8"
      }, primaryQuestion.question_text), /*#__PURE__*/React.createElement("p", {
        className: "body-text-2 mb-3 "
      }, associations.length > 1 ? "Your profile has 0 out of the ".concat(associations.length, " ").concat(primaryQuestion.question_text, " of this project.  Would you like to complete that information?") : "We noticed your profile doesn\u2019t have ".concat(primaryQuestion.question_key === 'stages_of_development' ? associations[0] : associations[0].name, " as a ").concat(primaryQuestion.question_text.split(' ').map(function (w) {
        return pluralize.singular(w);
      }).join(' '), ".  Would you like to add that information?")), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary update-profile-question",
        onClick: function onClick() {
          return _this2.handleShowQuestion();
        }
      }, "Add", ' ', primaryQuestion.question_text)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$state = this.state,
        showModal = _this$state.showModal,
        showQuestion = _this$state.showQuestion;
      var _this$props = this.props,
        questions = _this$props.questions,
        associations = _this$props.associations,
        consultantProfileId = _this$props.consultantProfileId,
        csrfToken = _this$props.csrfToken;
      var primaryQuestion = null;
      var associationQuestion = null;
      if (questions) {
        primaryQuestion = questions.find(function (question) {
          return question.parent_id == null;
        });
        associationQuestion = questions.find(function (question) {
          return question.association_model !== null;
        });
      }
      return /*#__PURE__*/React.createElement(Modal, {
        dialogClassName: "interest-in-project-submitted style-guide",
        show: showModal,
        onHide: function onHide() {
          return _this3.handleCloseModal();
        }
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true,
        className: "no-border-bottom"
      }), /*#__PURE__*/React.createElement(Modal.Body, null, showQuestion ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(QuestionsContainer, {
        questionnaireName: "Consultant Profile",
        questionIds: questions.map(function (q) {
          return q.id;
        }),
        questionableId: consultantProfileId,
        questionableType: "ConsultantProfile",
        csrfToken: csrfToken,
        closeModal: this.handleCloseModal,
        suggestedAnswers: _defineProperty({}, associationQuestion.question_key, associations),
        saveOnChange: true
      }), /*#__PURE__*/React.createElement("div", {
        className: "text-center"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-primary save",
        onClick: function onClick() {
          return _this3.handleCloseModal(true);
        }
      }, "Save"))) : this.renderInterestedCreated(primaryQuestion)));
    }
  }]);
}(Component);
InterestInProjectSubmitted.propTypes = {
  questions: PropTypes.shape([]),
  associations: PropTypes.shape([]),
  consultantProfileId: PropTypes.number.isRequired,
  csrfToken: PropTypes.string.isRequired
};
InterestInProjectSubmitted.defaultProps = {
  questions: [],
  associations: []
};
export default InterestInProjectSubmitted;